<template>
  <div class="home_page">
    <first></first>
    <second data-aos="fade-up"></second>
    <solution data-aos="fade-up"></solution>
    <four data-aos="fade-up"></four>
    <practice data-aos="fade-up" :practiceData="practiceData"></practice>
    <sample data-aos="fade-up"></sample>
    <seven data-aos="fade-up"></seven>
    <eight data-aos="fade-up"></eight>
  </div>
</template>

<script>
import first from './section/firstPage.vue';
import second from './section/secondPage.vue';
import four from './section/fourPage.vue';
import practice from '@/components/common/practice.vue';
import seven from './section/sevenPage.vue';
import eight from '@/components/common/beDevelop.vue';
import sample from '@/components/common/sample.vue';
import solution from './section/solution.vue';

export default {
  metaInfo: {
    title: '钒星北斗开放平台-卫星物联网',
    meta: [
      {
        name: 'keywords',
        content: '北斗短报文,北斗三号,北三短报文,窄带物联网,卫星物联网',
      },
      {
        name: 'description',
        content: '北斗技术经过多年技术积累，相关应用SDK简易快速上手，深度开放+服务响应速度快、安卓/苹果/PC全线技术支持',
      },
    ],
  },
  data() {
    return {
      practiceData: {
        title: '应用场景',
        items: [
          {
            id: '北斗户外应急语音通信',
            intro: '北斗户外应急语音通信',
            imgSrc: require('../assets/home/changjin-1.png'),
          },
          {
            id: '北斗海洋自动信息采集',
            intro: '北斗海洋自动信息采集',
            imgSrc: require('../assets/home/changjin-2.png'),
          },
          {
            id: '北斗户外赛事追踪',
            intro: '北斗户外赛事追踪',
            imgSrc: require('../assets/home/changjin-3.png'),
          },
          {
            id: '企业快速定制北斗APP',
            intro: '企业快速定制北斗APP',
            imgSrc: require('../assets/home/changjin-4.png'),
          },
        ],
      },
    };
  },
  name: 'HomeView',
  components: {
    first,
    second,
    four,
    practice,
    seven,
    eight,
    sample,
    solution,
  },
};
</script>


<style lang="scss" scoped>
.home_page {
  // 解决切换后首页aos滚动监听不到不显示的问题
  div {
    opacity: 1;
  }
}
</style>
